import SiteRender from '../microSite/core/components/render/siteRender.vue'
import { MICRO_SITE_TYPE } from '@/constant/common'
import { JOB_APPLICATION_SCOPE, POST_APPLICANT_SCOPE } from '@/constant/questionnaire'

export default {
  extends: SiteRender,
  data () {
    return {
      logo: {
        show: false,
        path: ''
      }
    }
  },
  computed: {
    type () {
      const questionnaireType = this.$parent.invitationInfo && this.$parent.invitationInfo.type
      if (questionnaireType === JOB_APPLICATION_SCOPE) {
        return MICRO_SITE_TYPE.job_application
      }
      if (questionnaireType === POST_APPLICANT_SCOPE) {
        return MICRO_SITE_TYPE.post_applicant
      }
      return MICRO_SITE_TYPE.satisfaction_survey
    }
  },
  created () {
    this.logo.show = true
    this.logo.path = this.$parent.logoPath
    this.pathPrefix = `/recruiting/questionnaire/${this.$route.params.invitationId}/site/${this.siteId}`
    this.initEventBus()
    this.initSitePages()
  },
  methods: {
    initEventBus () {
      this.$eventBus.$on('getMicroSiteNavigationLogo', callback => {
        callback(this.logo)
      })
      this.$eventBus.$on('microSiteNavigationLogoClick', this.onLogoClick)
    },
    onLogoClick () {
      const homePath = this.$parent.getQuestionnaireHomePath()
      if (homePath !== this.$route.path) {
        this.$router.push({ path: homePath, query: this.$route.query })
        this.$eventBus.$emit('setSelectMenuItem', 0)
      }
    }
  }
}
